import React from 'react';
// import '../assets/delete.css';

class User extends React.Component {
  render(){
    return(
      <span
        className="username"
        style={{ fontSize:"24px", background: "transparent", border: "none" }}
        onClick={()=>this.props.getUser(this.props.userId, this.props.username)}>
        @{this.props.username}
      </span>
    )
  }
}

export default User;